import { gql } from '@apollo/client';
import {
  CHILD_PROFILE_FIELDS,
  ROADMAP_FIELDS,
  TOY_SCHEDULE_ORDER_RESULT_FIELDS,
} from './Fragments';

export const GENERATE_ULTRA_PLAN_ROADMAP = gql`
  mutation GenerateUltraPlanRoadmap($data: UltraPlanRoadmapGenerationInput!) {
    generateUltraPlanRoadmap(data: $data) {
      data {
        ${ROADMAP_FIELDS}
      }
    }
  }
`;

export const ADD_ULTRA_PLAN_ROADMAP_WEEK = gql`
  mutation AddUltraPlanRoadmapWeek($data: UltraPlanRoadmapGenerationInput!) {
    addUltraPlanRoadmapWeek(data: $data) {
      data {
        ${ROADMAP_FIELDS}
      }
    }
  }
`;

export const UPSERT_ULTRA_PLAN_ROADMAP_SLOT = gql`
  mutation UpsertUltraPlanRoadmapSlot($data: UpsertUltraPlanRoadmapSlotInput!) {
    upsertUltraPlanRoadmapSlot(data: $data) {
      data {
        ${ROADMAP_FIELDS}
      }
    }
  }
`;

export const SWAP_ULTRA_PLAN_ROADMAP_SLOTS = gql`
  mutation SwapUltraPlanRoadmapSlots($data: SwapUltraPlanRoadmapSlotsInput!) {
    swapUltraPlanRoadmapSlots(data: $data) {
      data {
        ${ROADMAP_FIELDS}
      }
    }
  }
`;

export const CREATE_ULTRA_PLAN_CHILD_PROFILE = gql`
  mutation CreateChildProfile($data: CreateChildProfileInput) {
    createChildProfile(data: $data) {
      message
      data {
        ${CHILD_PROFILE_FIELDS}
      }
    }
  }
`;

export const UPDATE_ULTRA_PLAN_CHILD_PROFILE = gql`
  mutation UpdateChildProfile(
    $where: ChildProfileUniqueInput!
    $data: UpdateChildProfileInput
  ) {
    updateChildProfile(where: $where, data: $data) {
      message
      data {
        ${CHILD_PROFILE_FIELDS}
      }
    }
  }
`;

export const UPDATE_ULTRA_PLAN_ROADMAP_DOCUMENT = gql`
  mutation UpdateUserSubscription(
    $where: UserSubscriptionUniqueInput!
    $data: UpdateUserSubscriptionInput!
  ) {
    updateUserSubscription(where: $where, data: $data) {
      message
    }
  }
`;

export const PROCESS_TOY_SCHEDULE_ORDERS = gql`
  mutation ProcessToyScheduleOrders($data: ProcessToyScheduleOrdersInput!) {
    processToyScheduleOrders(data: $data) {
      message
      data {
        ${TOY_SCHEDULE_ORDER_RESULT_FIELDS}
      }
    }
  }
`;

export const REVIEW_ROADMAP_TOY_SWAP_SUGGESTION = gql`
  mutation ReviewRoadmapToySwapSuggestion(
    $data: ReviewRoadmapToySwapSuggestionInput!
  ) {
    reviewRoadmapToySwapSuggestion(data: $data) {
      data {
        id
        status
      }
    }
  }
`;
